import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=659b26f6&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=659b26f6&prod&lang=scss&scoped=true"
import style1 from "./Promotions.vue?vue&type=style&index=1&id=659b26f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659b26f6",
  null
  
)

export default component.exports